// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"zW x5","wrapperNeon":"zX yf","ribbon":"zY yc","title":"zZ x7","seasons":"z0 ya","genres":"z1 yb","buttonWrapper":"z2 x9","button":"z3 x-","buttonNeon":"z4 yh"};